// extracted by mini-css-extract-plugin
export var carouselContainer = "ReviewCarousel-module--carousel-container--WZU2u";